import { useState } from "react";
import ImageCard from "./ImageCard";

## Basic Usage

<ImageCard imageUrl="https://placehold.co/200x150/e2e8f0/475569?text=Image" />

---

## No Image (Fallback)

<ImageCard imageUrl={undefined} />

---

## Radio Card Type

export function RadioImageCards() {
  const [selected, setSelected] = useState("option1");
  return (
    <div style={{ display: "flex", gap: "1rem" }}>
      <ImageCard
        imageUrl="https://placehold.co/150x100/dbeafe/1e40af?text=A"
        cardType="radio"
        groupName="demo-group"
        optionName="Option A"
        optionValue="option1"
        active={selected === "option1"}
        onChange={() => setSelected("option1")}
      />
      <ImageCard
        imageUrl="https://placehold.co/150x100/dcfce7/166534?text=B"
        cardType="radio"
        groupName="demo-group"
        optionName="Option B"
        optionValue="option2"
        active={selected === "option2"}
        onChange={() => setSelected("option2")}
      />
      <ImageCard
        imageUrl="https://placehold.co/150x100/fef3c7/92400e?text=C"
        cardType="radio"
        groupName="demo-group"
        optionName="Option C"
        optionValue="option3"
        active={selected === "option3"}
        onChange={() => setSelected("option3")}
      />
    </div>
  );
}

<RadioImageCards />

---

## With Menu Items

export function ImageCardWithMenu() {
  return (
    <ImageCard
      imageUrl="https://placehold.co/200x150/f3e8ff/7c3aed?text=Logo"
      menuItems={[
        { children: "Edit", onClick: () => alert("Edit clicked") },
        { children: "Replace", onClick: () => alert("Replace clicked") },
        { children: "Delete", onClick: () => alert("Delete clicked") },
      ]}
    />
  );
}

<ImageCardWithMenu />

---

## Active State

<div style={{ display: "flex", gap: "1rem" }}>
  <ImageCard imageUrl="https://placehold.co/150x100/e2e8f0/475569?text=Default" />
  <ImageCard imageUrl="https://placehold.co/150x100/dbeafe/1e40af?text=Active" active />
</div>

---

## Disabled

<ImageCard
  imageUrl="https://placehold.co/200x150/e2e8f0/475569?text=Disabled"
  disabled
  menuItems={[{ children: "Won't show", onClick: () => {} }]}
/>

Menu items are hidden when disabled.

